import { Component, EventEmitter, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { InspectionsHttpService } from '@sentry/api-resources';
import { finalize } from 'rxjs/operators';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';

export interface Media {
  filePath: string;
  isImage: boolean;
  isVideo: boolean;
}

@UntilDestroy()
@Component({
    selector: 'sentry-media-upload',
    templateUrl: './media-upload.component.html',
    styleUrls: ['./media-upload.component.scss'],
    standalone: true,
    imports: [MatProgressBarModule, CommonModule]
})
export class MediaUploadComponent {
  @Output() mediaUploaded$: EventEmitter<Media> = new EventEmitter();

  isLoading = false;

  constructor(private readonly inspectionsService: InspectionsHttpService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uploadFile(event: any) {
    this.isLoading = true;
    const files: File[] = event.target.files;

    this.inspectionsService
      .upload(Array.from(files))
      .pipe(
        finalize(() => (this.isLoading = false)),
        untilDestroyed(this)
      )
      .subscribe((paths) => {
        const media: Media = {
          filePath: `https://mediafiles1.blob.core.windows.net/inspections/${paths[0]}`,
          isImage: paths[0].includes('.jpeg'),
          isVideo: paths[0].includes('.mp4') || paths[0].includes('.mov'),
        };

        this.mediaUploaded$.emit(media);
      });
  }
}
